import { TopProductsResponse } from "../../data/model/TopProductsResponse";
import { PopularProductModel } from "../models/PopularProductModel";

export const PopularProductModelMapper = {
  execute(dto: TopProductsResponse): PopularProductModel {
    const products = dto.products.map((product, index) => {
      return {
        productName: product.product_name,
        totalSales: `${product.total_amount} ${product.currency_code}`,
        totalOrders: product.total_quantity,
        rank: index + 1,
      };
    });

    return { products: products, file: dto.file };
  },
};
